export default {
  title: {
    id: 'asp_action_bar_declare_problem_item_not_received_upload_step_title',
    defaultMessage: 'Upload certificate of non-receipt for the agent to review',
  },
  itemNotReceived: {
    id: 'asp_action_bar_problem_declaration_message_step_subtitle_item_not_received',
    defaultMessage: 'Item not received',
  },
  intro: {
    id: 'asp_action_bar_declare_problem_item_not_received_upload_step_form_intro',
    defaultMessage:
      'The agent will look over the certificate, confirm their findings with you, and suggest next steps.',
  },
  uploadFieldLabel: {
    id: 'asp_action_bar_declare_problem_item_not_received_upload_step_upload_field',
    defaultMessage: 'Upload certificate',
  },
  hintTitle: {
    id: 'asp_action_bar_declare_problem_item_not_received_upload_step_hint_title',
    defaultMessage: 'Upload certificate of non-receipt',
  },
  hintMessage: {
    id: 'asp_action_bar_declare_problem_item_not_received_upload_step_hint_message',
    defaultMessage: 'Don’t have one? Use this template:',
  },
  hintLink: {
    id: 'asp_action_bar_declare_problem_item_not_received_upload_step_hint_link',
    defaultMessage: 'Download certificate template',
  },
}
